import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import gsap from "gsap";
import Video from "../components/Video";

const Home = () => {
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        document.getElementById("kodu").style.backgroundColor = "#FF8303"
        gsap.to(".bottle", {y:0, opacity:1})
        gsap.to(".text", {opacity:1, y:-38})
        gsap.to(".text2", {opacity:1, y:0, delay:0.2})
    }, [])

    const displayVideo = ()=> {
        setIsOpen(true)
        window.scrollTo(0,0)
        document.getElementById("main-container").style.class = "h-screen overflow-hidden w-full overflow-x-hidden"
    }

    return (
        <div id="main-container" class="w-full overflow-x-hidden">
            <Navbar></Navbar>

            <section class="gradient-main h-600 relative flex items-center overflow-hidden">
            <img alt="" class="absolute bg-deco h-full" src={require("../assets/background.png")}></img>
                <div class="ml-14 mb-14 title-contianer">
                    <h1 class="text font-title text-white text-4xl absolute translate-y-10 opacity-0">Sunsett Sipper</h1>
                    <p class="text2 font-sec text-white text-2xl absolute translate-y-10 opacity-0">Parim jook mida sa elus jood!</p>
                </div>
                <img class="bottle opacity-0  absolute -right-4 -top-24 translate-y-24 overflow-hidden" src={require("../assets/can.png")} alt="" />
                <div class="flex absolute -bottom-4">
                    <img alt="" src={require("../assets/cloud.png")}></img>
                    <img alt="" src={require("../assets/cloud.png")}></img>
                </div>
            </section>

            <section class="flex justify-center card-container">
                <div class="bg-color-2 w-1/4 rounded-md p-2 stroke-bottom card">
                    <div class="flex justify-center pt-2">
                        <img class=" w-10 h-10" alt="spark-icon" src={require("../assets/icons8-spark-100 (1).png")}></img>
                    </div>
                    <h1 class="text-center font-title text-2xl primary-2 pt-1">Kiire energija</h1>
                    <p class="text-center font-sec text-white text-xl pt-1">Saad endale kiire energija laksu kuna tegemist on energijajoogiga</p>
                </div>
                <div class="p-4">{ }</div>
                <div class="bg-color-2 w-1/4 rounded-md p-2 stroke-bottom card">
                    <div class="flex justify-center pt-2">
                        <img class=" w-10 h-10" alt="orange-icon" src={require("../assets/icons8-orange-96 (1).png")}></img>
                    </div>
                    <h1 class="text-center font-title text-2xl primary-2 pt-1">Maitsev</h1>
                    <p class="text-center font-sec text-white text-xl pt-1 pb-2">Oleme kaua mõelnud kuidas teha Sunsett sipper kõige maitsvamaks tooteks elus ja tabasime kullda!</p>
                </div>
                <div class="p-4">{}</div>
                 <div class="bg-color-2 w-1/4 rounded-md p-2 stroke-bottom card">
                    <div class="flex justify-center pt-2">
                        <img class=" w-10 h-10" alt="orange-icon" src={require("../assets/icons8-orange-96 (1).png")}></img>
                    </div>
                    <h1 class="text-center font-title text-2xl primary-2 pt-1">Energialaks</h1>
                    <p class="text-center font-sec text-white text-xl pt-1 pb-2">Tasakaalustatud kofeiinisisaldus, mis aitab sul end päeva jooksul tunda värskena ja energilisena.</p>
                </div>
            </section>

            <section class="bg-color-1 p-4 mt-20">
                <h1 class="text-white font-title text-2xl text-center">Mis ootad?</h1>
                <p class="text-white font-sec text-xl text-center mt-2 mb-6">Ostes saad proovida järgi uue generatsiooni jooki.</p>
                <div class="flex justify-center">
                    <button class="btn bg-color-0 rounded-full relative p-2 w-64" onClick={() => window.location.href = "#/buy"}>
                        <img class="absolute left-3 top-1.5" src={require("../assets/icons8-shopping-cart-96 2.png")} alt="" />
                        <h1 class="text-white font-title text-xl">Ostlema</h1>
                    </button>
                </div>
            </section>


            <section class="bg-color-1 p-8 mt-20 relative">
                <h1 class="text-white font-title text-2xl text-center">Pole veel veendund?</h1>
                <p class="text-white font-sec text-xl text-center mt-2 mb-6">Vaata kuidas VOCO õpilased hindavad seda!</p>
                <div class="flex justify-center">
                    <button class="bg-white w-96 h-40 rounded-md flex justify-center items-center relative video" onClick={()=>displayVideo()}>
                        <img alt="" class="absolute -top-14 -left-12" src={require("../assets/Star.png")}></img>
                        <img alt="play-button" src={require("../assets/play.png")}></img>
                        <img alt="" class="absolute -bottom-11 -right-14" src={require("../assets/Star-2.png")}></img>
                    </button>
                </div>
            </section>

            {isOpen && <Video setIsOpen={setIsOpen} />}
            <Footer isBottom={false}></Footer>
        </div>
    )
}

export default Home;